import { Controller } from "@hotwired/stimulus";
import {
  initBankTransactionsDatatable,
  updateBankTransactionsTableRows,
} from "../../datatables/bank_transactions_datatable";
import { isDatatableUninitialized } from "../../datatables/datatable_functions";

export default class extends Controller {
  initialize() {
    if (isDatatableUninitialized(this.element)) {
      initBankTransactionsDatatable(this.element);
    }

    document.addEventListener("bankTransaction:filesAttached", (e) => {
      updateBankTransactionsTableRows(e.detail.bankTransactions);
    });
  }
}
